<template>
  <div class="seminars" @selectstart.prevent="() => {}">
    <img :src="banner.imgUrl" class="cov-img page-banner" alt="">

    <div class="center">
      <pane-title title="专业研讨" sub-title="Seminars" />

      <div class="swiper-box">
        <swiper ref="swiper" class="zyyt-swiper" :options="disSwiperOptions">
          <swiper-slide v-for="item in discussionSwiper" :key="item.id">
            <div class="slide-box" @click="jumpUrl(item.jumpUrl)">
              <div class="img">
                <!--                <div class="mask"></div>-->
                <img class="cov-img" :src="item.pcImgUrl" alt="">
              </div>
              <div class="msg-box" @click="jumpUrl(item.jumpUrl)">
                <a class="tit" :href="item.jumpUrl" target="_blank">
                  {{item.title}}
                </a>
                <div class="sub-msg-box">
                  <div>
                    <div><img src="../../assets/activity/time.png" alt=""></div>
                    <span>{{ lang === 'zh' ? '活动时间' : 'Date' }}：{{item.time}}</span>
                  </div>
                  <div>
                    <div><img src="../../assets/activity/place.png" alt=""></div>
                    <span>{{ lang === 'zh' ? '活动形式' : 'Activities' }}：{{item.address}}</span>
                  </div>
                </div>
                <p class="right-link">
                  <a
                      class="link-tag-small"
                      :href="item.jumpUrl"
                      target="_blank"
                  >&lsaquo;&nbsp;{{lang === 'zh' ? '详情' : 'More'}}&nbsp;&rsaquo;</a>
                </p>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="btn next btn-next-1" @click="toNext()">
          <img src="../../assets/activity/swiper-right.jpg" alt="">
        </div>
        <div class="btn prev btn-prev-1" @click="toPrev()">
          <img src="../../assets/activity/swiper-left.jpg" alt="">
        </div>
      </div>

      <div class="meeting-box">
        <div class="year-item" v-for="(item, i) in meetingListByYear" :key="i">
          <div class="year"><span>{{item.publishTime}}</span></div>

<!--          <img-->
<!--              v-if="item.list.length > 6"-->
<!--              class="toggle-btn"-->
<!--              :src="require('../../assets/activity/' + (item.showAll ? 'down-icon.png' : 'right-icon.png'))"-->
<!--              alt=""-->
<!--              @click="item.showAll = item.list.length > 6 ? !item.showAll : true"-->
<!--          >-->

          <div class="meet-list">
<!--            <div class="meet-item" v-for="(mit, mi) in (item.showAll ? item.list : item.list.slice(0, 6))" :key="mi">-->
            <div class="meet-item" v-for="(mit, mi) in item.list" :key="mi">
              <p class="meet-tit">{{mit.title}}</p>
              <div class="sub-msg">
                <div>
                  <img src="../../assets/activity/time.png" alt="">
                  <span>{{mit.time}}</span>
                </div>
                <div>
                  <img src="../../assets/activity/place.png" alt="">
                  <span>{{mit.address}}</span>
                </div>
              </div>

              <div v-if="mit.tag" class="right-bottom-tag">
                {{mit.tag}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activityPageData } from "../../utils/Local-Data";
const { tabList, discussionSwiper, scienceSwiper, meetingSwiper } = activityPageData;

export default {
  name: "Seminars",
  data() {
    return {
      banner: {},
      commonOptions: {
        autoplay: {
          disableOnInteraction: false
        },
        autoDestroy: true,
        deleteInstanceOnDestroy: true,
        observeParents: true,
        observer: true,
        observeSlideChildren:true
      },
      disSwiperOptions: {
        // autoplay: true,
        // duration: 5000,
        spaceBetween: 15,
        // slidesOffsetBefore: '25%',
        // slidesOffsetAfter: 80,
        loop: true,
        slideShadows: true,
        slidesPerView: 3,
        // centeredSlides: true,
        // pagination: {
        //   el: '.n-p-pagination',
        //   clickable: true
        // }
      },
      discussionSwiper: [],
      meetingList: [],
      meetingListByYear: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    },
    swiper() {
      return this.$refs.swiper.$swiper;
    }
  },
  methods: {
    jumpUrl(url) {
      console.log(url);
      if(url) {
        window.open(url);
      }
    },
    onTabChange(id) {
      this.currentTab = id;
      // this['swiper' + id].slideTo(0);
    },
    toPrev(id) {
      this.swiper.slidePrev();
    },
    toNext(id) {
      this.swiper.slideNext();
    },
    filterData(records) {
      this.meetingList = records['401'];
      this.createMLBY();
    },
    createSwiperList(records) {
      const idList = records['403'][0].content;
      const _list = records['401'].filter(item => {
        return idList.indexOf(item.id) >= 0;
      });
      this.discussionSwiper = _list.map(item => {
        const [time, address, tag] = item.description.split('&');
        return {
          ...item,
          time, address, tag
        }
      })
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '4',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
        this.createSwiperList(res.crmOweContentMaps || {});
        this.banner = res.imageMaps['40'][0];
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    },
    createMLBY() {
      let ml = this.meetingList.sort((a, b) => b.publishTime - a.publishTime);
      const yearList = [];
      ml = ml.map(item => {
        if (yearList.indexOf(item.publishTime) < 0) {
          yearList.push(item.publishTime);
        }
        const [time, address, tag] = item.description.split('&');
        return {
          ...item,
          time, address, tag
        }
      });

      const finallyMeeting = [];
      yearList.forEach(item => {
        const _list = ml.filter(it => it.publishTime === item)
        finallyMeeting.push({
          publishTime: item,
          list: _list.sort((a, b) => b.time >= a.time ? 1 : -1),
          showAll: _list.length <= 6
        })
      })

      this.meetingListByYear = finallyMeeting;
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  }
}
</script>

<style lang="less">
.pc-home {
  .seminars {
    .zyyt-swiper {
      .slide-box {
        border: 1px solid #6F6F6F;
        .img img {
          display: block;
          width: 100%;
          height: 218px;
          object-fit: cover;
        }
        .msg-box {
          padding: 40px;
          .tit {
            display: inline-block;
            height: 47px;
            font-size: 18px;
            line-height: 29px;
            font-weight: bold;
            margin-bottom: 48px;
            cursor: pointer;
            color: #037698;
            text-decoration: none;
          }
        }
        .sub-msg-box {
          margin-bottom: 30px;
          >div {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              display: block;
              width: 18px;
              height: 18px;
              margin-right: 10px;
            }
            span {
              color: #5F5F5F;
            }
          }
        }
        .right-link {
          text-align: right;
        }
      }

    }
    .swiper-box {
      //padding: 0 80px;
      margin-bottom: 92px;
      position: relative;
      .btn {
        position: absolute;
        top: 0;
        cursor: pointer;
        line-height: 499px;
        img {
          width: 50px;
          height: 97px;
        }
      }
      .prev {
        left: -80px;
      }
      .next {
        right: -80px
      }
    }

    .meeting-box {
      .year {
        color: #037698;
        font-size: 70px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 30px;
        span {
          display: inline-block;
          transform: scale(0.76, 1);
        }
      }
      .toggle-btn {
        display: block;
        margin: 0 auto 33px;
        cursor: pointer;
      }

      .meet-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        border-bottom: 1px solid #6F6F6F;
        padding-bottom: 18px;
        margin-bottom: 92px;
        .meet-item {
          width: calc((100% - 48px) / 2);
          padding: 33px 56px 23px;
          box-shadow: 0 4px 8px 0 rgba(0,17,24,0.26);
          margin-bottom: 48px;
          position: relative;
          .meet-tit {
            color: #2E2E2E;
            line-height: 27px;
            height: 45px;
            margin-bottom: 25px;
          }
          .sub-msg {
            display: flex;
            >div {
              display: flex;
              align-items: center;
              margin-right: 56px;
              img {
                display: block;
                width: 18px;
                height: 18px;
                margin-right: 10px;
              }
              span {
                color: #5F5F5F;
              }
            }
          }
          .right-bottom-tag {
            width: 99px;
            height: 25px;
            line-height: 25px;
            text-align: right;
            padding-right: 20px;
            color: #fff;
            position: absolute;
            right: 0;
            bottom: 0;
            background-size: 100% 100%;
            background-image: url("../../assets/activity/rb-banner.jpg");
          }
        }
      }
    }
  }
}
</style>
